import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetOpsQuery } from '../redux/apis/analyticsManagement/aMOpsApiSlice'

const AssigneeDropdown = ({
  onChange,
  onBlur,
  value,
  className,
  mode,
  disabled = false,
  label="Assignee"
}) => {
  const { data, isLoading, error } = useGetOpsQuery({
    page: '*'
  })

  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  let options

  if (data) {
    options = data?.data?.map(user => ({
      label: `${user.name} (${user.email})`,
      value: user.id
    }))
  }

  return (
    <div className='mb-3'>
      <Loader isLoading={isLoading} />
      <label className='form-label'>{label}</label>
      <br />
      <Select
        name='assignee'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        placeholder='Select an assignee'
        optionFilterProp='label'
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={options}
        mode={mode}
        disabled={disabled}
      />
    </div>
  )
}

export default AssigneeDropdown
